module.exports = __webpack_public_path__ + "c0b3f4b8ab77ca0c33a7da5a8519d316.png";